import { useCallback, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Panel, inputCls } from "@/components/Peep";
import { ProfileImagePick } from "@/components/ProfileImagePick";


export default function CreatorProfile() {
  const [params] = useSearchParams();
  const [c, setC] = useState(null);
  const [form, setForm] = useState({ display_name: "", bio: "" });
  const load = useCallback(() => {
    api.get("/creator/profile").then((r) => {
      setC(r.data.creator);
      setForm({ display_name: r.data.creator.display_name, bio: r.data.creator.bio || "" });
    }).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (extra = {}) => {
    try {
      await api.put("/creator/profile", { ...form, ...extra });
      toast.success("Profile saved");
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };
  const saveImage = (key) => (id) => api.put("/creator/profile", { [key]: id });
  if (!c) return <p className="text-sm text-[#a7a0af]">Loading…</p>;
  return (
    <div data-testid="creator-profile" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">My profile</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">What subscribers see on @{c.handle}. Your handle is managed by the administrator. <Link to={`/app/c/${c.handle}`} data-testid="profile-view-public" className="text-[#f0a8fa] underline">View my public page</Link></p>
      </div>
      {params.get("welcome") && (
        <div data-testid="creator-welcome" className="rounded-2xl border border-[#d42be8]/40 bg-[#d42be8]/10 p-4 text-sm text-[#f0a8fa]">
          Welcome to PEEPING, {c.display_name}. Complete your profile: add a photo, a cover and a short bio, then save. Next, set your price under Membership and schedule your first live session.
        </div>
      )}
      <Panel title="Details">
        <div className="grid gap-3 md:grid-cols-2">
          <label className="flex flex-col gap-1 text-xs text-[#a7a0af]">Display name<input className={inputCls} data-testid="profile-display-name" value={form.display_name} onChange={(e) => setForm({ ...form, display_name: e.target.value })} /></label>
          <label className="flex flex-col gap-1 text-xs text-[#a7a0af]">Bio<input className={inputCls} data-testid="profile-bio" value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} /></label>
          <ProfileImagePick label="Avatar" url={c.avatar_url} save={saveImage("avatar_asset_id")} onSaved={load} testid="profile-avatar-input" />
          <ProfileImagePick label="Profile banner (top of your public page)" hint={c.cover_url ? undefined : c.banner_url && c.promo_published ? "Using your discovery hero banner until you add one" : undefined} url={c.cover_url} save={saveImage("cover_asset_id")} onSaved={load} testid="profile-cover-input" />
        </div>
        <button onClick={() => save()} data-testid="profile-save" className="btn-brand mt-4 rounded-xl px-5 py-2.5 text-sm font-semibold">Save profile</button>
      </Panel>
    </div>
  );
}
